import * as React from 'react';

export const EmployerCompanyModalFooterContext = React.createContext<{
  setFooter: (node: React.ReactNode) => void;
} | null>(null);
